import React, { useEffect, useState } from "react";

const AttendanceTable = (props) => {
    let [dataset, set_dataset] = useState([]);
    useEffect(() => {
        if (props.data.length > 0) {
            set_dataset(props.data);
        }
    }, [props.data]);

    async function updateCount(value, index) {
        let count = props.count;
        if (value <= count) {
            dataset[index].count = value;
        }
    }

    return (
        <div className="flex column w-100">
            <div className="flex justifyStart alignCenter table_header">
                {props.tableHeaders.map((header, index) => (
                    <h3 key={index + 1} className="table_header_element" style={{
                        width:
                            index === 0 ? 40 :
                                index === 1 ? 160 :
                                    index === 2 ? 160 :
                                        index === 3 ? 100 :
                                            index === 4 ? 160 :
                                                index === 5 ? 120 :
                                                    160,
                        textAlign: (index === 0 || index === 1) ? 'right' : 'center'
                    }}>{header}</h3>
                ))}

                {dataset.length > 0 && (
                    <div className="flex justifyEnd alignCenter print_button"
                        style={{ margin: "0 8px" }}
                        onClick={() => {
                            let list = []
                            list = dataset.map((item) => ({ id: item['id'], count: item['count'] }));
                            props.uploadBulkAttandance(list)
                        }}>
                        حاضری محفوظ کریں
                    </div>
                )}
            </div>

            <div className="flex column justifyStart alignCenter tabe_data_row">
                {props.data.length > 0 && props.data.map((attendance, index) => (
                    <div className="flex justifyStart alignCenter table_row" key={index + 1}>
                        <h4 style={{ width: 40, textAlign: 'right' }}>{index + 1}</h4>
                        <div className="flex justifyStart alignCenter" style={{ width: 160 }}>
                            <img src={attendance['student'].image_url} width={36} height={36} alt="profile_picture" style={{ borderRadius: '50%' }} />
                            <h3 style={{ marginRight: 12 }}>{attendance['student'].name}</h3>
                        </div>
                        <h3 style={{ width: 160, textAlign: 'center' }}>{attendance['class_room'].name}</h3>
                        <h3 style={{ width: 100, textAlign: 'center' }}>{attendance['section']['name'].urdu}</h3>
                        <h3 style={{ width: 160, textAlign: 'center' }}>{props.count}</h3>
                        <div className="flex justifyCenter alignCenter" style={{ width: 120 }}>
                            <input type="number"
                                style={{
                                    height: 32,
                                    width: 48,
                                    textAlign: 'center',
                                    paddingRight: 3,
                                    fontSize: 18,
                                    fontWeight: 700
                                }}
                                defaultValue={attendance['count']}
                                min="1"
                                max={props.count}
                                onChange={(event) => updateCount(Number(event.target.value), index)}
                            />
                        </div>
                    </div>
                ))}

                {props.data.length === 0 && (
                    <div className="flex justifyCenter alignCenter table_row">
                        <h3>{`ایدمین کی طرف سے آج کی تاریخ میں اس درجہ کی حاضری کا کوئی ڈیٹا موصول نہیں ہوا۔`}</h3>
                    </div>
                )}
            </div>
        </div >
    );
}

export default AttendanceTable;